<template>
  <div class="overflow-x-auto" v-bind="$attrs">
    <table
      :class="tableClass"
      class="w-full table-auto border-collapse border ltr:font-sans text-xs"
    >
      <thead>
        <slot name="tableHeadersPre"></slot>
        <slot name="tableHeaders">
          <tr class="py-2 ps-3 border border-brand-gray-300 text-start">
            <th
              :key="key"
              v-for="(h, key) in headers.length > 0 ? headers : defaultHeaders"
              class="p-1 border border-gray-100"
            >
              <slot :label="h" name="headerCell">
                {{ $t(h) }}
              </slot>
            </th>
          </tr>
        </slot>
        <slot name="tableHeadersPost"></slot>
      </thead>

      <slot name="tableBody">
        <tbody v-if="dataSet?.length > 0">
          <tr
            :key="rowKey"
            v-for="(row, rowKey) in dataSet"
            class="odd:bg-brand-gray-150 ltr:font-sans text-xs"
          >
            <td
              :key="colKey"
              v-for="([name, value], colKey) in Object.entries(row)"
              :class="bodyCellClass"
              class="p-1 ps-2 border border-gray-100 ltr:font-sans text-xs"
            >
              <slot :columnName="name" :columnValue="value" :rowIndex="rowKey" name="cell">
                {{ value }}
              </slot>
            </td>
          </tr>
          <slot name="tableFooter"></slot>
        </tbody>
        <tbody v-else>
          <slot name="emptyBody">
            <tr>
              <td
                :colspan="
                  Object.keys(headers).length > 0
                    ? Object.keys(headers).length
                    : defaultHeaders.length
                "
                class="p-2 text-center"
              >
                {{ $t(emptyMessage) }}
              </td>
            </tr>
          </slot>
        </tbody>
      </slot>
    </table>
  </div>
</template>

<script setup>
import { computed } from 'vue'
const props = defineProps({
  defaultHeaders: {
    type: Array,
    default: () => []
  },
  tableClass: String,
  dataSet: Array,
  bodyCellClass: String,
  emptyMessage: {
    type: String,
    default: () => 'NoRecordFound'
  }
})

const headers = computed(() => {
  return Object.keys(props?.dataSet?.[0] || {})
})
</script>

<script>
export default { name: 'DataTable' }
</script>

<style lang="scss" scoped></style>
